import { OverlayModule } from '@angular/cdk/overlay';
import { PlatformModule } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { LycorisModule } from '@lycoris-nubila/ngx-lycoris';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { DynamicDialogModule } from 'primeng/dynamicdialog';

import { AddCoachMeetingDialogComponent } from 'dialog/add-coach-meeting-dialog/add-coach-meeting-dialog.component';
import { AddTodoTaskDialogComponent } from 'dialog/add-todo-task-dialog/add-todo-task-dialog.component';
import { AddUserNoteDialogComponent } from 'dialog/add-user-note-dialog/add-user-note-dialog.component';
import { ArticleViewerDialogComponent } from 'dialog/article-viewer-dialog/article-viewer-dialog.component';
import { CoacheeMoodDialogComponent } from 'dialog/coachee-mood-dialog/coachee-mood-dialog.component';
import { DocumentViewerDialogComponent } from 'dialog/document-viewer-dialog/document-viewer-dialog.component';
import { EditTaskDialogComponent } from 'dialog/edit-task-dialog/edit-task-dialog.component';
import { MeetingAlternativeDialogComponent } from 'dialog/meeting-alternative-dialog/meeting-alternative-dialog.component';
import { MeetingRequestDialogComponent } from 'dialog/meeting-request-dialog/meeting-request-dialog.component';
import { MfaEngageDialogComponent } from 'dialog/mfa-engage-dialog/mfa-engage-dialog.component';
import { SetModuleCommentDialogComponent } from 'dialog/set-module-comment-dialog/set-module-comment-dialog.component';
import { SetModuleRatingDialogComponent } from 'dialog/set-module-rating-dialog/set-module-rating-dialog.component';
import { BlockTitleComponent } from 'presentation/common/component/block-title/block-title.component';
import { FormSliderComponent } from 'presentation/common/component/form-slider/form-slider.component';
import { PageFilterComponent } from 'presentation/common/component/page-filter/page-filter.component';
import { UserMetadataComponent } from 'presentation/common/component/user-metadata/user-metadata.component';
import { BadgeDirective } from 'presentation/common/directive/badge.directive';
import { SpyDirective } from 'presentation/common/directive/spy.directive';
import { InterpolatePipe } from 'presentation/common/pipe/interpolate.pipe';
import { MomentPipe } from 'presentation/common/pipe/moment.pipe';
import { PipeModule } from 'presentation/common/pipe/pipe.module';

import { AppPrimengModule } from './app-primeng.module';
import { FirstCoachingPlanModuleDialogComponent } from './presentation/common/dialog/first-coaching-plan-module-dialog/first-coaching-plan-module-dialog.component';

@NgModule({
	declarations: [
		BlockTitleComponent,
		AddCoachMeetingDialogComponent,
		MomentPipe,
		InterpolatePipe,
		PageFilterComponent,
		FormSliderComponent,
		DocumentViewerDialogComponent,
		MeetingRequestDialogComponent,
		UserMetadataComponent,
		MeetingAlternativeDialogComponent,
		ArticleViewerDialogComponent,
		SetModuleCommentDialogComponent,
		SetModuleRatingDialogComponent,
		AddTodoTaskDialogComponent,
		CoacheeMoodDialogComponent,
		BadgeDirective,
		SpyDirective,
		EditTaskDialogComponent,
		MfaEngageDialogComponent,
		AddUserNoteDialogComponent,
		FirstCoachingPlanModuleDialogComponent,
	],
	imports: [
		CommonModule,
		LycorisModule,
		FormsModule,
		PipeModule,
		OverlayModule,
		PlatformModule,
		CKEditorModule,
		NgScrollbarModule,
		AppPrimengModule,
		ReactiveFormsModule,
		RouterModule,
		TranslateModule.forChild(),
		NgxDocViewerModule,
		DynamicDialogModule,
	],
	exports: [
		PipeModule,
		LycorisModule,
		PlatformModule,
		NgScrollbarModule,
		BlockTitleComponent,
		CKEditorModule,
		CommonModule,
		FormsModule,
		OverlayModule,
		AppPrimengModule,
		ReactiveFormsModule,
		MomentPipe,
		InterpolatePipe,
		PageFilterComponent,
		FormSliderComponent,
		RouterModule,
		TranslateModule,
		NgxDocViewerModule,
		DynamicDialogModule,
		UserMetadataComponent,
		BadgeDirective,
		SpyDirective,
	],
	providers: [],
})
export class AppSharedModule {}
